import { render, staticRenderFns } from "./PriceSuggestionConfigurationList.vue?vue&type=template&id=1c66689a&"
import script from "./PriceSuggestionConfigurationList.vue?vue&type=script&lang=js&"
export * from "./PriceSuggestionConfigurationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c66689a')) {
      api.createRecord('1c66689a', component.options)
    } else {
      api.reload('1c66689a', component.options)
    }
    module.hot.accept("./PriceSuggestionConfigurationList.vue?vue&type=template&id=1c66689a&", function () {
      api.rerender('1c66689a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/catalog/price-suggestion-configuration/PriceSuggestionConfigurationList.vue"
export default component.exports